import { Component } from '@angular/core';
import { TranslateModule } from '@ngx-translate/core';

@Component({
    selector: 'app-fp-key-features',
    imports: [TranslateModule],
    templateUrl: './fp-key-features.component.html',
    styleUrl: './fp-key-features.component.scss'
})
export class FpKeyFeaturesComponent {}